import React from "react";
import { graphql } from "gatsby";
import { markdownToHTML } from "utils";
import { Row, Col } from "antd";

import getIcon from "components/Icons";
import { SecondaryButton } from "components/Buttons";
import HTMLContainer from "components/HTMLContainer";

import * as styles from "./SectionContentCards.module.less";

/**
 * We use this to define what will be queried for this component
 * This also serves as typings (See `Gatsby.SectionContentCardsDataFragment` below)
 */
export const SectionContentCardsDataFragment = graphql`
  fragment SectionContentCardsData on MarkdownRemarkFrontmatterSections {
    title
    columns
    cards {
      title
      body
      button {
        title
        icon
        url
      }
    }
    section_id
  }
`;

/**
 * @param {GatsbyTypes.SectionContentCardsDataFragment} props
 */
export default function SectionContentCards(props) {
  const { title, columns, cards = [], section_id } = props;
  return (
    <section id={section_id} className={styles.container}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <Row
        gutter={{
          sm: 12,
          md: 32, // 2rem
        }}
        justify="center"
      >
        {cards.map(({ title, body, button }, idx) => (
          <Col key={idx} xs={24} lg={24 / columns}>
            <div className={styles.cardContainer}>
              <h3 className={styles.cardTitle}>{title}</h3>
              <HTMLContainer
                html={markdownToHTML(body)}
                className={styles.cardContent}
              />
              {button && (
                <SecondaryButton
                  className={styles.button}
                  to={button.url}
                  title={button.title}
                  // @ts-expect-error
                  icon={button.icon && getIcon(button.icon, { width: 20 })}
                />
              )}
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
}
